/* nrd-hjem.js: bare progressive forbedringer, ingen avhengigheter.
   Alt innhold er synlig og banene kan scrolles uten denne fila.
   Legger pilknapper til hver .nrd-baneramme som er merket med data-nrd-bane. */
(function () {
  var PIL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function lagPil(merkelapp, snu) {
    var k = document.createElement('button');
    k.type = 'button';
    k.className = 'nrd-bane__pil';
    k.setAttribute('aria-label', merkelapp);
    k.innerHTML = PIL;
    if (snu) { k.firstChild.style.transform = 'rotate(180deg)'; }
    return k;
  }

  function koble(ramme) {
    var bane = ramme.querySelector('.nrd-bane');
    if (!bane || ramme.getAttribute('data-nrd-koblet')) { return; }
    ramme.setAttribute('data-nrd-koblet', '1');
    var rad = document.createElement('div');
    rad.className = 'nrd-bane__piler';
    var forrige = lagPil('Forrige', true);
    var neste = lagPil('Neste', false);
    rad.appendChild(forrige);
    rad.appendChild(neste);
    ramme.appendChild(rad);

    /* Mellomrommet leses av banen, ikke antatt, slik at en seksjon kan sette sitt eget gap. */
    function mellomrom() {
      var g = parseFloat(getComputedStyle(bane).columnGap);
      return isNaN(g) ? 0 : g;
    }
    function steg() {
      var post = bane.firstElementChild;
      return post ? post.getBoundingClientRect().width + mellomrom() : bane.clientWidth * 0.8;
    }
    /* Nettleseren følger argumentet, ikke scroll-behavior i stilarket, så den som har
       bedt om mindre bevegelse må få 'auto' her. */
    function oppforsel() {
      var sp = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      return sp && sp.matches ? 'auto' : 'smooth';
    }
    function rull(retning) {
      bane.scrollBy({ left: retning * steg(), behavior: oppforsel() });
    }
    function oppdater() {
      var slutt = bane.scrollWidth - bane.clientWidth - 2;
      rad.hidden = slutt <= 0;
      forrige.disabled = bane.scrollLeft <= 2;
      neste.disabled = bane.scrollLeft >= slutt;
    }
    forrige.addEventListener('click', function () { rull(-1); });
    neste.addEventListener('click', function () { rull(1); });
    bane.addEventListener('scroll', oppdater, { passive: true });
    window.addEventListener('resize', oppdater);
    oppdater();
  }

  function start() {
    var rammer = document.querySelectorAll('[data-nrd-bane]');
    for (var i = 0; i < rammer.length; i++) { koble(rammer[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
